import { ExpenseCategoriesTable } from "components";

const ExpenseCategories = () => {

    return (
        <ExpenseCategoriesTable />
    );

}
export default ExpenseCategories;
